import { apiSlice } from 'store/slices/api/api-slice';
import { ImageSuccessResponse } from 'types/card/card-sphere';
import { PersonageImagesRequest } from 'types/card/card-personage-list';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        personageImageUpdate: builder.mutation<
            ImageSuccessResponse,
            PersonageImagesRequest
        >({
            query: (personageImagesRequest: PersonageImagesRequest) => ({
                url:
                    `/personage/add-personage-image/` +
                    personageImagesRequest.cardPersonageId,
                method: 'POST',
                //credentials: 'include',
                body: personageImagesRequest.image,
                header: {},
            }),
        }),

        personageBackgroundImageUpdate: builder.mutation<
            ImageSuccessResponse,
            PersonageImagesRequest
        >({
            query: (personageImagesRequest: PersonageImagesRequest) => ({
                url:
                    `/personage/add-personage-background-image/` +
                    personageImagesRequest.cardPersonageId,
                method: 'POST',
                //credentials: 'include',
                body: personageImagesRequest.image,
                header: {},
            }),
        }),
    }),
});

export const {
    usePersonageImageUpdateMutation,
    usePersonageBackgroundImageUpdateMutation,
} = importTradeDataApiSlice;
